/*
 * sdx-announcement-slider — vanilla, section-scoped slider for announcement bar.
 * Respects prefers-reduced-motion. Pauses off-screen + on hover (configurable).
 * Re-initialises on Shopify section editor events (load / block select).
 */
(function () {
  'use strict';

  var MQ_REDUCED = '(prefers-reduced-motion: reduce)';

  function init(root) {
    if (!root || root.__sdxAnnInit) return;
    root.__sdxAnnInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.sdx-announcement__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sdx-announcement__dot'));
    if (slides.length <= 1) return;

    var autoplay = root.dataset.autoplay === 'true';
    var delay = parseInt(root.dataset.autoplayDelay || '5000', 10);
    var pauseOnHover = root.dataset.pauseOnHover === 'true';
    var reduced = window.matchMedia && window.matchMedia(MQ_REDUCED).matches;

    var index = 0;
    var timer = null;
    var visible = true;
    var hovered = false;

    function show(next) {
      if (next === index) return;
      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      if (dots[index]) dots[index].setAttribute('aria-current', 'false');

      index = (next + slides.length) % slides.length;

      slides[index].classList.add('is-active');
      slides[index].setAttribute('aria-hidden', 'false');
      if (dots[index]) dots[index].setAttribute('aria-current', 'true');
    }

    function next() { show(index + 1); }

    function start() {
      stop();
      if (!autoplay || reduced) return;
      if (!visible) return;
      if (hovered && pauseOnHover) return;
      timer = window.setInterval(next, delay);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Dots
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    // Hover pause
    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () { hovered = true; stop(); });
      root.addEventListener('mouseleave', function () { hovered = false; start(); });
      root.addEventListener('focusin', function () { hovered = true; stop(); });
      root.addEventListener('focusout', function () { hovered = false; start(); });
    }

    // Off-screen pause
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) start(); else stop();
        });
      }, { threshold: 0.01 });
      io.observe(root);
      root.__sdxAnnIO = io;
    }

    // Reduced motion live reaction
    if (window.matchMedia) {
      var mm = window.matchMedia(MQ_REDUCED);
      var onChange = function (e) { reduced = e.matches; if (reduced) stop(); else start(); };
      if (mm.addEventListener) mm.addEventListener('change', onChange);
      else if (mm.addListener) mm.addListener(onChange);
    }

    start();
    root.__sdxAnnStop = stop;
    root.__sdxAnnStart = start;
    root.__sdxAnnShow = show;
  }

  function destroy(root) {
    if (!root || !root.__sdxAnnInit) return;
    if (root.__sdxAnnStop) root.__sdxAnnStop();
    if (root.__sdxAnnIO && root.__sdxAnnIO.disconnect) root.__sdxAnnIO.disconnect();
    root.__sdxAnnInit = false;
  }

  function bootAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-sdx-announcement]');
    Array.prototype.forEach.call(roots, function (r) { init(r); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  // Shopify section editor hooks
  document.addEventListener('shopify:section:load', function (e) {
    bootAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-sdx-announcement]');
    if (r) destroy(r);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-sdx-announcement]');
    if (!root) return;
    var slide = e.target.closest('.sdx-announcement__slide');
    if (!slide) return;
    var idx = parseInt(slide.getAttribute('data-index') || '0', 10);
    if (root.__sdxAnnStop) root.__sdxAnnStop();
    if (root.__sdxAnnShow) root.__sdxAnnShow(idx);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-sdx-announcement]');
    if (root && root.__sdxAnnStart) root.__sdxAnnStart();
  });
})();
